import { Container, Grid } from "@material-ui/core";
import Menu from "../../Components/Menu";
import styled from "@emotion/styled";
import S2 from "../../img/S2.png";

const S2_About = () => {
  const MainDiv = styled.div`
    // background-size: cover;
    // background-repeat: no-repeat;
    // background-position-y: bottom;
  `;
  const Span = styled.span`
    color: #ffffff;
    font-size: 44px;
    text-transform: uppercase;
    font-weight: 600;
    padding-bottom: 10px;
    @media screen and (max-width:599px){
      font-size: 34px;

      
    }
  `;
  const P = styled.p`
    color: #ffffff;
    padding-top: 30px;
  `;
  return (
    <MainDiv className="py-5" id="Home">
      <Container>
        <Grid
          container
          justifyContent="center"
          alignContent="center"
          alignItems="center"
          className=""
        >
          <Grid xs={12} sm={12} md={5} className="text-left">
            <h1 className="fontweight">
              <Span>
              &nbsp; BRIEF COMPANY <br></br>
                <Span style={{ borderBottom: "7px solid #B82E3C" }}>
                  &nbsp; PROFILE  &nbsp; &nbsp;
                </Span>
              </Span>
            </h1>
            <P>
            Four brothers was established 25 years ago in pakistan. we are a dynamic and progressive organization registered with securities and exchange commission of pakistan .our dedicated services and support have been translated into successful track record of various projects and ensuring consistent growth, we have evolved into a well-known name representing renowned global industries in Pakistan. we are working with corporate national / international organizations as consultants. 
we undertake impact assessment, feasibility study, market research report for government; marketing services; brand building; market research and studies; government specifications; impact assessment studies and feasibility studies.</P>
<P>We at four brothers are concerned with the future and our journey towards it. employing innovative consulting approaches between management and technology, we pave the way into the digital age for companies from all industries. our consulting approach enables us to serve the entire spectrum of digitalization, from innovation and prototyping to the implementation of smart solutions. our sights are always set on the potential of the latest technology trends, and we go far beyond the limits of the technological horizon. 
</P>
<P>Four brothers is originally housed in Pakistan and now has spread its wings and presence in Manama, kingdom of Bahrain. our staff comprises it, marketing and finance professionals. our contact details are as follows :</P>
          </Grid>
          <Grid xs={12} sm={12} md={1}></Grid>
          <Grid xs={12} sm={12} md={6} className="">
            <img src={S2} className="img-fluid w-100" />
          </Grid>
        </Grid>
      </Container>
    </MainDiv>
  );
};

export default S2_About;
